import { Delete, Edit, RemoveRedEye } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';

export const Actions = ({ onDelete, onEdit, onView, row, showDelete = true, showEdit = true, showView = true }: { onDelete: any, onEdit: any, onView?: any, showDelete?: boolean, showEdit?: boolean, showView?: boolean, row: any }) => {
    return <Box sx={{ display: 'flex ', gap: '6px', justifyContent: 'center' }}>

        {
            showEdit ? <Tooltip title="Edit " >
                <Edit sx={{ width: '30px', height: '30px', backgroundColor: '#32CD33', borderRadius: '100%', padding: '6px', color: 'white' }} onClick={() => { onEdit(row) }} />
            </Tooltip> : null
        }

        {
            showView && onView ?
                <Tooltip title="View " >
                    <RemoveRedEye sx={{ width: '30px', height: '30px', backgroundColor: '#3150A1', borderRadius: '100%', padding: '6px', color: 'white' }} onClick={() => { onView(row) }} />
                </Tooltip> : null
        }

        {
            showDelete ? <Tooltip title="Delete ">
                <Delete sx={{ width: '30px', height: '30px', backgroundColor: '#FF0000', borderRadius: '100%', padding: '6px', color: 'white' }} onClick={() => { onDelete(row) }} />
            </Tooltip> : null
        }

    </Box>
}